import { render, staticRenderFns } from "./show.countdowns.page.vue?vue&type=template&id=fbd1528a&scoped=true&"
import script from "./show.countdowns.page.vue?vue&type=script&lang=js&"
export * from "./show.countdowns.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd1528a",
  null
  
)

export default component.exports